export default "__VITE_ASSET__Bp5VcEFm__"